import { render, staticRenderFns } from "./ArticleViewLogModal.vue?vue&type=template&id=297d5272&scoped=true"
import script from "./ArticleViewLogModal.vue?vue&type=script&lang=js"
export * from "./ArticleViewLogModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297d5272",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('297d5272')) {
      api.createRecord('297d5272', component.options)
    } else {
      api.reload('297d5272', component.options)
    }
    module.hot.accept("./ArticleViewLogModal.vue?vue&type=template&id=297d5272&scoped=true", function () {
      api.rerender('297d5272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/articleViewLog/modules/ArticleViewLogModal.vue"
export default component.exports